import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import axios from "axios";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from '@material-ui/icons/Search';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Loader from "../Global/Loader/Index";
import AlertMessage from "../../components/Global/Message/Alert";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import * as globalFuncs from '../../globalFuncs/Entities/Product/Index'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    cursor: {
        cursor: "pointer",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
    unread: {
        fontWeight: 'bold',
        border: '2px solid #2780af',
        backgroundColor: '#f5f5c8',
    },
    mainCr: {
        flexGrow: 1,
    },
}));

const FactorManagerIsUnpaid = () => {

    const classes = useStyles();
    const [pageLoading, setPageLoading] = React.useState(true);
    const [factorList, setFactorList] = useState({});
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [id, setId] = useState(0);
    const [btnLoading, setBtnLoading] = useState(false);

    const [status, setStatus] = useState(false);

    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    const [searchValue, setSearchValue] = useState("");

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const handleClickOpen = (id, state) => {
        setOpen(true);
        setId(id);
        setStatus(state);
    };

    const handleClose = () => {
        setOpen(false);
        setId("");
    };

    const searchFactorsText = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/invoices/list?page=1&InvoiceId=${searchValue}&ispaid=false`,
                config
            )
            if (data.status === "ok") {
                setFactorList(data.data.invoices);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const searchFactors = async (value) => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/invoices/list?page=${value}&InvoiceId=${searchValue}&ispaid=false`,
                config
            );
            if (data.status === "ok") {
                setFactorList(data.data.invoices);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const changeStatus = async () => {
        setBtnLoading(true);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                `/api/admin/invoices/update`,
                { invoiceId: id, isPaid: status },
                config
            );
            if (data.status === "ok") {
                toggleOpenAlert("success", "وضعیت با موفقیت بروزرسانی شد");
                handleClose();
                getFactors();
                setBtnLoading(false);
            } else {
                toggleOpenAlert("error", "خطا در تغییر وضعیت");
                handleClose();
                setBtnLoading(false);
            }
        } catch (e) {
            console.log(e);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            handleClose();
            setBtnLoading(false);
        }
    };

    const getFactors = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/invoices/list?page=${currentPage}&ispaid=false`,
                config
            );
            if (data.status === "ok") {
                setFactorList(data.data.invoices);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    useEffect(() => {
        getFactors();
    }, []);

    return (
        <>
            <Box mt={2} mb={4} px={2}>
                <Grid container >
                    <Grid item xs={7}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="شماره فاکتور"
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Box pl={2}>
                            <Button
                                onClick={searchFactorsText}
                                className={classes.btnSearch}
                                fullWidth
                                color="seconday"
                                variant="contained"
                            ><SearchIcon />جستجو</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box px={2} mt={1}>
                <Box
                    bgcolor="#950000"
                    borderRadius={10}
                    color="#fff"
                    p={2}
                    textAlign="center">
                    <Grid container>
                        <Grid xs={1}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">ردیف</Box>
                        </Grid>
                        <Grid xs={2}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">شماره فاکتور</Box>
                        </Grid>
                        <Grid xs={2}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">شماره خریدار</Box>
                        </Grid>
                        <Grid xs={2}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">نام خریدار</Box>
                        </Grid>
                        <Grid xs={1}>
                            <Box justifyContent="center" alignItems="center" height="100%">تاریخ خرید</Box>
                        </Grid>
                        <Grid xs={2}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">مبلغ</Box>
                        </Grid>
                        <Grid xs={1}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">پرداخت</Box>
                        </Grid>
                        <Grid xs={1}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%">عملیات</Box>
                        </Grid>
                    </Grid>
                </Box>
                {(pageLoading) ? (
                    <Box mt={3}>
                        <Loader text="در حال بارگزاری..." />
                    </Box>
                ) : (
                    (factorList.length) > 0 ? (
                        factorList.map((item, i) => (
                            <Box
                                style={{ padding: "25px 15px 25px 15px" }}
                                bgcolor="#fff"
                                borderRadius={10}
                                boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                mt={2}
                                className={(!item.isOpen) ? classes.unread : ''}
                                textAlign="center">
                                <Grid container>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{i + 1}</Box>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{item.invoiceNumber}</Box>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{item.mobileNumber}</Box>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{item.fullName}</Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{item.date}</Box>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">{globalFuncs.SepratePrice2(item.totalSum.toString(), 'fa')}</Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                            color={item.isPaid ? "#28A504" : "#950000"}>
                                            {!item.isPaid ? (
                                                <CheckBoxOutlineBlankIcon />
                                            ) : (
                                                <CheckBoxIcon />
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">
                                            <Link target="_blank" to={`/factors/detail/${item.invoiceNumber}`}>
                                                <a
                                                    style={{ color: "#818181" }}
                                                    className={classes.cursor}>
                                                    <VisibilityIcon color="inherit" />
                                                </a>
                                            </Link>&nbsp;&nbsp;
                                                    <a
                                                onClick={() => {
                                                    handleClickOpen(item.invoiceNumber, item.isPaid);
                                                }}
                                                className={classes.cursor}>
                                                <EditIcon color="primary" />
                                            </a>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        ))
                    ) : (
                        <Box mt={3} mb={1}>
                            <AlertMessage variant="info">
                                موردی جهت نمایش وجود ندارد.
                                </AlertMessage>
                        </Box>
                    )

                )}
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                mt={2}
                mb={2}
                alignItems="center">
                <Pagination
                    count={pages}
                    page={currentPage}
                    variant="outlined"
                    shape="rounded"
                    onChange={(e, value) => {
                        setCurrentPage(value);
                        searchFactors(value);
                    }}
                />
            </Box>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="alert-dialog-slide-title">
                    ویرایش وضعیت فاکتور
                </DialogTitle>
                <DialogContent style={{ minWidth: "400px" }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">
                                وضعیت
                            </InputLabel>
                            <Select
                                fullWidth
                                name="category"
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                label="  وضعیت"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}>
                                <MenuItem disabled value="">
                                    <em> انتخاب کنید</em>
                                </MenuItem>
                                <MenuItem value="false">پرداخت نشده</MenuItem>
                                <MenuItem value="true">پرداخت شده</MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        width="100%">
                        <Button
                            variant="contained"
                            onClick={handleClose}
                            className={classes.btnRed}>
                            انصراف
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            onClick={changeStatus}
                            color="secondary"
                            variant="contained">
                            {btnLoading ? (
                                <CircularProgress size={25} color="inherit" />
                            ) : (
                                <>اعمال تغییرات</>
                            )}{" "}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default FactorManagerIsUnpaid;
